import { takeLatest, put } from "redux-saga/effects";

import supportService from "../../../services/support";
import {
  createSubjectStart,
  createSubjectSuccess,
  createSubjectFailure,
  getSupportSubjectsStart,
  getSupportSubjectsSuccess,
  getSupportSubjectsFailure,
  getSupportMessagesStart,
  getSupportMessagesSuccess,
  getSupportMessagesFailure,
  createMessage
} from "../../redux/support/chatsupport";
import { showSuccessMessage, showErrorMessage } from "../../redux/toast";

function* supportWatcher() {
  yield takeLatest(createSubjectStart.type, createSubjectStartWorker);
  yield takeLatest(getSupportSubjectsStart.type, getSupportSubjectsStartWorker);
  yield takeLatest(getSupportMessagesStart.type, getSupportMessagesStartWorker);
  yield takeLatest(createMessage.type, createMessageWorker);
}

function* createSubjectStartWorker(action) {
  try {
    const { data, status } = yield supportService.createSubjectStartDetails(
      action.payload
    );
    if (data) {
      const { messageSent } = data;
      yield put(createSubjectSuccess(messageSent));
      if (messageSent) {
        yield put(
          showSuccessMessage({ tKey: "SUPPORT_MODAL.SUBJECT_CREATED" })
        );
      }
    }
    if (status !== 200) {
      yield put(createSubjectFailure());
      yield put(
        showErrorMessage({ tKey: "SUPPORT_MODAL.SUBJECT_NOT_CREATED" })
      );
    }
  } catch (error) {
    yield put(createSubjectFailure());
    yield put(showErrorMessage({ tKey: "SUPPORT_MODAL.SUBJECT_NOT_CREATED" }));
  }
}

function* getSupportSubjectsStartWorker(action) {
  try {
    const { data, status } = yield supportService.getSupportSubjectsDetails(
      action.payload
    );
    if (data) {
      const { rows } = data;
      yield put(getSupportSubjectsSuccess(data));
      yield put(getSupportMessagesStart(rows[0]?.id));
    }
    if (status !== 200) {
      yield put(getSupportSubjectsFailure());
    }
  } catch (error) {
    yield put(getSupportSubjectsFailure());
  }
}

function* getSupportMessagesStartWorker(action) {
  try {
    const { data, status } = yield supportService.getSupportMessagesDetails(
      action.payload
    );
    if (data) {
      yield put(getSupportMessagesSuccess(data));
    }
    if (status !== 200) {
      yield put(getSupportMessagesFailure());
    }
  } catch (error) {
    yield put(getSupportMessagesFailure());
  }
}

function* createMessageWorker(action) {
  yield;
  try {
    const { data, status } = yield supportService.createMessageDetails(
      action.payload
    );
    if (data) {
      const { messageSent } = data;
      if (messageSent) {
        yield put(showSuccessMessage({ tKey: "SUPPORT_MODAL.MESSAGE_SENT" }));
      }
    }
    if (status !== 200) {
      yield put(createSubjectFailure());
      yield put(showErrorMessage({ tKey: "SUPPORT_MODAL.MESSAGE_NOT_SENT" }));
    }
  } catch (error) {
    return error;
  }
}

export default supportWatcher;
